import { render } from "./Assignments.vue?vue&type=template&id=0f8823c1"
import script from "./Assignments.vue?vue&type=script&lang=ts"
export * from "./Assignments.vue?vue&type=script&lang=ts"
script.render = render

export default script